import React, { useContext } from 'react';
import { AppContext } from 'shared/AppContext';
import Customers from './components/Customers';

const Users = () => {
  const { state } = useContext(AppContext);
  const accountId = state?.accountId;

  return (
    <div
      style={{
        background: 'transparent',
      }}
    >
      <Customers accountId={accountId} />
    </div>
  );
};

export default Users;
